import axios from 'axios';
import { decodeTrimmedKeyPem, decryptData, encryptData } from './encryptionHelper.js';
const { v4: uuidv4 } = require('uuid');

const CUSTOMER_PUBLIC_KEY = process.env.REACT_APP_CUSTOMER_PUBLIC_KEY;
const CUSTOMER_PRIVATE_KEY = process.env.REACT_APP_CUSTOMER_PRIVATE_KEY;
const API_PUBLIC_KEY = process.env.REACT_APP_API_PUBLIC_KEY;

function getHeaders() {
  return { 'Content-Type': 'application/json' }
}
const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  // timeout: 1000,
  headers: getHeaders()
})

function getLanguage() {
  return localStorage?.getItem('language')
    ? localStorage?.getItem('language')
    : 'en'
}

instance.interceptors.request.use(config => {
  const method = config.method?.toUpperCase()
  if ((method === 'GET' || method === 'DELETE') && Object.keys(config.params || {}).length > 0) {
    config.params.public_key = decodeTrimmedKeyPem(CUSTOMER_PUBLIC_KEY);
    config.params.device_type = "web";
    let jsonParams = JSON.stringify(config.params)
    const encrypted = encryptData(API_PUBLIC_KEY, jsonParams)
    config.params = {
      encryptedData: encrypted.encryptedData,
      encryptedKey: encrypted.encryptedKey,
      encryptedIV: encrypted.iv,
      public_key: decodeTrimmedKeyPem(CUSTOMER_PUBLIC_KEY),
      device_type: 'web'
    }
  } else if (method === 'POST' || method === 'PUT') {
    if (!(config.data instanceof FormData)) {
      config.data.public_key = decodeTrimmedKeyPem(CUSTOMER_PUBLIC_KEY);
      config.data.device_type = "web";
      let jsonData = JSON.stringify(config.data)
      const encrypted = encryptData(API_PUBLIC_KEY, jsonData)
      config.data = {
        encryptedData: encrypted.encryptedData,
        encryptedKey: encrypted.encryptedKey,
        encryptedIV: encrypted.iv,
        public_key: decodeTrimmedKeyPem(CUSTOMER_PUBLIC_KEY),
        device_type: 'web'
      }
    }
    else {
      config.data.append('public_key', decodeTrimmedKeyPem(CUSTOMER_PUBLIC_KEY));
      config.data.append('device_type', 'web');
    }
  }


  const token = localStorage.getItem('token')
  config = {
    ...config,
    headers: { ...config.headers, language: getLanguage(), 'Idempotency-Key': uuidv4()  }
  }
  if (!token) {
    return config
  }
  // document.getElementById('loader').classList.remove('hidden')
  config = {
    ...config,
    headers: { ...config.headers, Authorization: `Bearer ${token}` }
  }

  return config
})

instance.interceptors.response.use(
  function (response) {
    // Do something with response data
    document.getElementById('loader')?.classList?.add('hidden')
    const responseData = response.data
    if (responseData?.encryptedData && responseData?.encryptedKey && responseData?.iv) {
      try {
        const decrypted = decryptData(CUSTOMER_PRIVATE_KEY, responseData?.encryptedData, responseData?.encryptedKey, responseData?.iv)
        response.data = JSON.parse(decrypted)
        return response
      } catch (e) {
        console.error('Decryption failed', e)
        return response
      }
    }
    return response
  },
  function (error) {
    const { status } = error.response
    if (status === 401) {
      localStorage.removeItem('token')
      localStorage.removeItem('refresh_token')
      localStorage.removeItem('uniqueId')
      window.location = '/login'
    } else if (status === 403) {
      localStorage.removeItem('token')
      localStorage.removeItem('refresh_token')
      localStorage.removeItem('uniqueId')
      window.location = '/login'
    } else if (status === 409) {
      localStorage.removeItem('token')
      localStorage.removeItem('refresh_token')
      localStorage.removeItem('uniqueId')
      window.location = '/login'
    }
    return Promise.reject(error)
  }
)

function apiGet(url, params = {}) {
  return instance.get(url, { params })
}

function apiPost(url, body, config = null) {
  return instance.post(url, body, config)
}

function apiPut(url, body, config = null) {
  return instance.put(url, body, config)
}

function apiDelete(url) {
  return instance.delete(url)
}

export { apiDelete, apiGet, apiPost, apiPut, getHeaders };

